'use client'

import {
  useCart,
  useCheckout,
  useModals,
  useSearchParams,
  useSelectedCustomer,
} from '@/lib/hooks'
import { cn } from '@/lib/utils'
import { Plus } from 'lucide-react'
import React from 'react'

import { BackButton, Button, Hint } from '@/components/ui'

export const CartHeader = () => {
  const { openModal } = useModals()
  const { cart } = useCart()
  const { showMobileCart, isCheckout, setSearchParams } = useSearchParams()
  const { customer, } = useSelectedCustomer()
  const { currentStep, setCurrentStep } = useCheckout()

  const handleBackClick = React.useCallback(() => {
    setSearchParams({ isCheckout: false, showMobileCart: false })
  }, [setSearchParams])

  return (
    <div
      className={cn(
        'flex w-full items-center gap-3',
        customer &&
        currentStep !== 'SELECT_CUSTOMER' &&
        'border-b border-dashed border-gray-100 pb-4',
      )}
    >
      {(isCheckout || showMobileCart) && (
        <BackButton size="icon" onClick={handleBackClick} />
      )}
      <div className="flex w-full flex-col">
        <h2 className="text-base font-medium">Current Order</h2>
        <Hint>{cart?.cart_items?.length} Items in the cart</Hint>
      </div>

      {currentStep === 'ADD_PRODUCTS' && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              openModal('ADD_CART_DISCOUNT')
            }}
          >
            <Plus className="size-4" />
            <span>Cart Discount</span>
          </Button>
        </div>
      )}

      {customer &&
        currentStep !== 'SELECT_CUSTOMER' &&
        currentStep !== 'ADD_PRODUCTS' && (
          <div
            className="flex shrink-0 cursor-pointer items-center gap-2"
            onClick={() => setCurrentStep('SELECT_CUSTOMER')}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setCurrentStep('SELECT_CUSTOMER')
              }
            }}
          >
            <div className="flex items-center gap-2">
              <div className="flex flex-col text-right">
                <span className="text-sm font-medium">{customer?.name}</span>
                <span className="text-sm font-medium text-gray-500">
                  {customer?.phone}
                </span>
                {customer?.total_loyalty_value !== undefined && customer.total_loyalty_value !== null && (
                  <span className="text-sm font-medium text-gray-500">
                    Loyalty Points: {customer.total_loyalty_value}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </div>
  )
}
